import React from 'react'

const hr = (
  <div style={{marginTop: '32px', marginBottom: '32px', borderBottom: '1px solid rgb(212,212,212)'}}></div>
)

export {hr}
